query GetEventCheckIn($id: ID!) {
  event(id: $id) {
    id
    title
    startsAt
    endsAt
    timezone
    checkInClosedAt
    checkedInCount
    noShowCount
    checkInGuests {
      id
      firstName
      lastName
      company
      jobTitle
      status
      plusOne
      guestOf
      checkedInAt
      checkedInByName
      avatarUrl
    }
  }
}
